import * as qs from 'qs';
import {API} from '../API';
import {ItemService} from './ItemService';

export class PurchaseOrderService {

  constructor() {
    this.item = new ItemService();
  }

  async getTableOrders(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getOrders(query, page, length);
  }

  async getOrders(query, page, length) {
    return (await API.getConnection())
      .get('purchase-orders', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async saveOrder(data) {
    let method = 'post';
    let url = 'purchase-orders';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async getOrder(id, archive = false) {
    return (await API.getConnection())
      .get(`purchase-orders/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async downloadOrder(order) {
    return (await API.getConnection())
      .get(`purchase-orders/${order.id}/download`, {
        responseType: 'blob',
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['x-filename']);
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => API.handleError(error));
  }

  async lockOrder(order) {
    return (await API.getConnection())
      .put(`purchase-orders/${order.id}/lock`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async unlockOrder(order) {
    return (await API.getConnection())
      .put(`purchase-orders/${order.id}/unlock`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async duplicateOrder(order) {
    return (await API.getConnection())
      .post(`purchase-orders/${order.id}/duplicate`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteOrder(order) {
    return (await API.getConnection())
      .delete(`purchase-orders/${order.id}`)
      .then(() => null)
      .catch(error => API.handleError(error));
  }

  async restoreOrder(order) {
    return (await API.getConnection())
      .put(`purchase-orders/${order.id}/restore`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
